const allTags: Record<string, string[]> = {
	colours: ["red", "green", "yellow", "blue", "purple", "pink", "white", "orange"],
	stems: [
		"lilies",
		"rose",
		"freesia",
		"germini",
		"orchids",
		"tulips",
		"carnations",
		"daisies",
		"sunflowers",
		"peonies",
		"crysanthemums",
	],
};

export type AvailableTags = Record<string, string[]>;

export function computeAvailableTags(products: any[]): AvailableTags {
	const result: AvailableTags = {};
	for (const tagType of Object.keys(allTags)) {
		result[tagType] = [];
	}

	for (const product of products) {
		if (!product?.product_meta?.keywords || product.product_meta.keywords === "") continue;
		const keywords = product.product_meta.keywords.split(",");

		for (const keyword of keywords) {
			const trimmed = keyword.trim();
			for (const tagType of Object.keys(allTags)) {
				if (allTags[tagType].includes(trimmed) && !result[tagType].includes(trimmed)) {
					result[tagType].push(trimmed);
				}
			}
		}
	}

	return result;
}
